module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0097.jpg?v=fd92e2a8";